<template>
    <fragment>
        <v-main>
            <!--       <v-container      set-container mt-md-10-->
            <v-card v-cloak class="mx-2 mx-md-9 mt-6 mb-16 top-level-responsive-sides-padding px-md-6 text-center"
                elevation="8">
                <v-row v-show="homeProgressBar || saveProgressBar" class="mt-10">
                    <v-col cols="12">

                        <!--<div
                                                            class="text-subtitle-1 text-center mb-3"
                                                        >
                                                            Just a moment ...
                                                        </div>-->

                        <!--                                <v-progress-linear
                                                            :indeterminate="homeProgressBar || saveProgressBar"
                                                            color="primary"
                                                            rounded
                                                            height="6"
                                                            :active="homeProgressBar || saveProgressBar"

                                                        ></v-progress-linear>-->

                        <!--                                    :boilerplate="true"-->
                        <!--                                :loading="true"-->

                        <v-skeleton-loader v-show="true" light
                            type="card:table: table-heading, table-thead, table-tbody"></v-skeleton-loader>
                    </v-col>

                </v-row>

                <v-row v-show="!saveProgressBar" class="mb-12">
                    <v-col>
                        <v-tabs-items v-model="currentTab">
                            <!--                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.users" :transition="false">-->
                            <!--                                <users-and-categories-tab ref="usersTabRef"></users-and-categories-tab>-->
                            <!--                            </v-tab-item>-->

                            <!--                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.filter" :transition="false">-->

                            <!--                                <internet-filter-tab ref="internetFilterTabRef"-->
                            <!--                                                     :currentFilterMode.sync="currentFilterMode"-->
                            <!--                                                     :currentSelectedRule.sync="currentSelectedRule"-->
                            <!--                                                     :currentSelectedRuleKey.sync="currentSelectedRuleKey"-->
                            <!--                                                     :isShowFilter.sync="isShowFilter"-->
                            <!--                                                     :ruleCompact.sync="ruleCompact"></internet-filter-tab>-->

                            <!--                            </v-tab-item>-->

                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.applications">
                                <profile-application-tab ref="mobileAppsTabRef"></profile-application-tab>
                            </v-tab-item>
                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.usageTime" :transition="false">
                                <usage-time-tab></usage-time-tab>
                            </v-tab-item>
                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.personalControls" :transition="false">
                                <personal-controls-tab></personal-controls-tab>
                            </v-tab-item>
                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.categories" :transition="false">
                                <categories-tab></categories-tab>
                            </v-tab-item>
                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.groups" :transition="false">
                                <groups-tab ref="groupsTabRef"></groups-tab>
                            </v-tab-item>
                            <v-tab-item v-if="!homeProgressBar" :key="tabIndices.security" :transition="false">
                                <v-row>
                                    <v-col>

                                        <v-row>
                                            <v-col :lg="currentSelectedConfiguration ? 3 : 12"
                                                :md="currentSelectedConfiguration ? 4 : 12"
                                                :xl="currentSelectedConfiguration ? 2 : 12" class="border-right-divider"
                                                cols="12">

                                                <v-list
                                                    v-if="currentViewConfigurationCount() > 0 && hideMobileListingForMobileIfListingItemSelectedForConfigurations()"
                                                    class="v-list-wrapper groups-tab-list">

                                                    <!--                    color="primary"-->
                                                    <v-list-item-group v-model="currentSelectedConfiguration">
                                                        <draggable v-model="configurations"
                                                            :options="{ disabled: $vuetify.breakpoint.mdAndDown }"
                                                            @end="syncConfigurations()">

                                                            <!-- :class is required because the v-list-item-group works toggle's it's active state and we do want to lose the focus. Otherwise on the second tap active class is lost -->
                                                            <v-list-item v-for="(configuration) in configurations"
                                                                v-show="configurationSelectedForMobile() && checkEachConfiguration(configuration.key)"
                                                                :class="{ 'v-item--active v-list-item--active v-list-item-active primary--text': !!(currentSelectedConfiguration && configuration.key && currentSelectedConfiguration === configuration.key) }"
                                                                :value="configuration.key" class="px-0" ripple
                                                                @click="selectConfiguration(configuration.key)">

                                                                <v-list-item-content>

                                                                    <v-list-item-title
                                                                        :class="{ 'add-border-list-on-small-devices': $vuetify.breakpoint.xsOnly }"
                                                                        class="text-left">

                                                                        <v-hover v-slot="{ hover }">
                                                                            <v-row>
                                                                                <v-col
                                                                                    :class="{ 'pl-4 pt-0 pb-0': $vuetify.breakpoint.xsOnly, 'py-0': $vuetify.breakpoint.smAndUp }"
                                                                                    class="body-2 text-truncate align-flex-start"
                                                                                    cols="9" md="10" sm="7">
                                                                                    <span class="pl-2 text-truncate"
                                                                                        v-text="configuration.key"></span>


                                                                                </v-col>
                                                                                <v-col
                                                                                    :class="{ 'align-flex-end pt-0': $vuetify.breakpoint.xsOnly, 'align-flex-end': $vuetify.breakpoint.smAndUp }"
                                                                                    class="pr-4 ml-auto" cols="3" md="2"
                                                                                    sm="5">

                                                                                    <v-menu>
                                                                                        <template
                                                                                            v-slot:activator="{ on, attrs }">
                                                                                            <v-btn icon v-bind="attrs"
                                                                                                v-on="on">
                                                                                                <v-icon
                                                                                                    v-text="icons.mdiDotsVertical"></v-icon>
                                                                                            </v-btn>
                                                                                        </template>

                                                                                        <v-list dense flat>
                                                                                            <!--                                                            @click="openAddEditConfigurationDialog('edit', configuration.key, currentSelectedConfiguration)"-->
                                                                                            <v-list-item
                                                                                                :value="currentSelectedConfiguration"
                                                                                                @click="openAddEditDeviceMobileDialogV2('edit', configuration)">
                                                                                                <v-list-item-title
                                                                                                    class="font-weight-regular">
                                                                                                    <v-icon
                                                                                                        :color="!isDark ? 'primary' : ''"
                                                                                                        class="mr-1"
                                                                                                        size="18"
                                                                                                        v-text="icons.mdiPencilCircleOutline"></v-icon>
                                                                                                    {{ $gettext('Edit')
                                                                                                    }}
                                                                                                </v-list-item-title>
                                                                                            </v-list-item>
                                                                                            <v-list-item
                                                                                                :value="currentSelectedConfiguration"
                                                                                                @click="deleteConfiguration(configuration.key)">
                                                                                                <v-list-item-title
                                                                                                    class="font-weight-regular">
                                                                                                    <v-icon class="mr-1"
                                                                                                        :color="!isDark ? 'primary' : ''"
                                                                                                        size="18"
                                                                                                        v-text="icons.mdiDeleteCircleOutline"></v-icon>
                                                                                                    {{
                                                                                                        $gettext('Delete')
                                                                                                    }}
                                                                                                </v-list-item-title>
                                                                                            </v-list-item>
                                                                                        </v-list>
                                                                                    </v-menu>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-hover>
                                                                    </v-list-item-title>
                                                                    <v-list-item-subtitle
                                                                        v-if="configuration.value.userInfo.mdmDeviceId"
                                                                        class="text-left pl-2 text-truncate caption grey--text font-weight-light"
                                                                        v-text="configuration.value.userInfo.mdmDeviceId">
                                                                    </v-list-item-subtitle>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </draggable>
                                                    </v-list-item-group>
                                                </v-list>

                                            </v-col>

                                            <v-col v-if="currentSelectedConfiguration">


                                                <security-tab></security-tab>

                                                <!-- Safesearch -->
                                                <!-- <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="text-left">{{ $gettext('Safesearch') }}</v-list-item-title>
                                                        <v-list-item-subtitle class="text-left">
                                                            {{ $gettext('Force Google and some other search engines in Safesearch mode') }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="safeSearchEnabled" @change="updateSecuritySettings"/>
                                                    </v-list-item-action>
                                                </v-list-item> -->

                                                <!-- Youtube Restrict -->
                                                <!-- <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="text-left">{{ $gettext('Youtube Restrict') }}</v-list-item-title>
                                                        <v-list-item-subtitle class="text-left">
                                                            {{ $gettext('Set Youtube in Youtube-restrict mode') }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="youtubeRestrictEnabled" @change="updateSecuritySettings"/>
                                                    </v-list-item-action>
                                                </v-list-item> -->

                                                <!-- Google Safe Browsing -->
                                                <!-- <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="text-left">{{ $gettext('NextDNS list') }}</v-list-item-title>
                                                        <v-list-item-subtitle class="text-left">
                                                            {{ $gettext('Block Ads and Malware') }}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch v-model="googleSafeBrowsingEnabled" @change="updateSecuritySettings"/>
                                                    </v-list-item-action>
                                                </v-list-item> -->

                                                <!-- Ads and Malware Section -->

                                                <!-- NextDNS list -->
                                                <!--<v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="text-left">{{ $gettext('NextDNS list') }}</v-list-item-title>
                                                            <v-list-item-subtitle class="text-left">{{ $gettext('Block Ads and Malware') }}</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-switch :true-value="1" :false-value="0" v-model="options.nextDNS"/>
                                                        </v-list-item-action>
                                                    </v-list-item>-->

                                                <!-- OISD -->
                                                <!--<v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="text-left">OISD</v-list-item-title>
                                                            <v-list-item-subtitle class="text-left">Block Ads and Malware <a href="https://oisd.nl" target="_blank">oisd.nl</a></v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-switch :true-value="1" :false-value="0" v-model="options.oisd"/>
                                                        </v-list-item-action>
                                                    </v-list-item>-->

                                                <!-- AdGuard Mobile Ads filter -->
                                                <!--<v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="text-left">AdGuard Mobile Ads filter</v-list-item-title>
                                                        <v-list-item-subtitle class="text-left">Block Ads and Malware <a href="https://kb.adguard.com/general/adguard-ad-filters#mobile-ads-filter" target="_blank">mobile-ads-filter</a></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-switch :true-value="1" :false-value="0" v-model="options.adGuard"/>
                                                    </v-list-item-action>
                                                </v-list-item>
                                                -->


                                                <!-- Secure navigation on Google -->
                                                <!--    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="text-left">Secure navigation on Google</v-list-item-title>
                                                            <v-list-item-subtitle class="text-left">Block Ads and Malware</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-switch :true-value="1" :false-value="0" v-model="options.secureGoogle"/>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                    -->

                                                <!-- Block trackers -->
                                                <!--
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="text-left">Block trackers</v-list-item-title>
                                                            <v-list-item-subtitle class="text-left">Block Ads and Malware</v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-switch :true-value="1" :false-value="0" v-model="options.blockTrackers"/>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                    -->

                                                <snackbar ref="snackbar"></snackbar>
                                            </v-col>
                                        </v-row>


                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>
                </v-row>
            </v-card>
        </v-main>
        <v-footer fixed>
            <v-row>
                <v-col v-if="(currentTab === 2 && $vuetify.breakpoint.smAndDown)"
                    class="text-center primary text-center white--text" cols="12" @click="openCreateProfileDialog()">
                    <v-icon class="mr-2" color="white" v-text="icons.mdiPlusCircleOutline"></v-icon>
                    {{ $gettext('Create Profile') }}
                </v-col>
                <v-col v-if="(currentTab === 1 && $vuetify.breakpoint.smAndDown && currentSelectedRule)"
                    class="text-center primary text-center white--text" cols="12">
                    <div v-if="currentSelectedRule" class="cursor-pointer d-flex align-center justify-center"
                        @click="clearCurrentSelectedRule()">
                        <v-icon class="white--text mr-2" small v-text="icons.mdiArrowLeftCircle"></v-icon>
                        {{ $gettext('Back to Rules') }}
                    </div>
                    <!--<div v-else>

                        <v-row class="text-center" v-if="isShowFilter">
                            <v-col cols="4" class="pa-0 border-separator-right">
                                <v-btn class="py-8 footer-button" color="primary" @click="pushAFilterRule({'active': 'on'}, 'active')">
                                    <v-icon left>{{ icons.mdiFilterCheck }}</v-icon>
                                    Active
                                </v-btn>
                            </v-col>

                            <v-col cols="4" class="pa-0 border-separator-right">
                                <v-btn class="py-8 footer-button" color="primary" @click="pushAFilterRule(false, 'all')">
                                    <v-icon left>{{ icons.mdiFilterOff }}</v-icon>
                                    All
                                </v-btn>
                            </v-col>

                            <v-col cols="4" class="pa-0 border-separator-right">
                                <v-btn class="py-8 footer-button" color="primary" @click="pushAFilterRule({'active': 'off'}, 'inactive')">
                                    <v-icon left>{{ icons.mdiFilter }}</v-icon>
                                    Inactive
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-divider class="my-3" dark v-if="isShowFilter"></v-divider>

                        <v-row class="text-center">
                            <v-col cols="6" class="pa-0 border-separator-right">
                                <v-btn class="py-8 footer-button" color="primary" @click="toggleFilter()" :input-value="isShowFilter ? 1: 0">
                                    <v-icon left>{{ icons.mdiFilter }}</v-icon>

                                    <span v-if="isShowFilter">Hide Filter</span>
                                    <span v-else>Filter</span>
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="text-center pa-0" @click="openAddEditRuleDialog()">
                                <v-btn class="py-8 footer-button" color="primary">
                                    <v-icon left>{{ icons.mdiAccountPlus }}</v-icon>
                                    Add Rule
                                </v-btn>
                            </v-col>
                        </v-row>

                    </div>-->
                </v-col>
                <v-col v-else-if="(currentTab === 4 && $vuetify.breakpoint.smAndDown)"
                    class="text-center primary text-center white--text" cols="12">
                    <div v-if="currentSelectedGroup" class="cursor-pointer" @click="clearCurrentSelectedGroup()">
                        <v-icon class="white--text">{{ icons.mdiArrowLeftCircle }}</v-icon>
                        {{ $gettext('Back to Groups') }}
                    </div>
                    <v-row v-else class="cursor-pointer">
                        <v-col @click="$refs.groupsTabRef.openAddEditFolderDialog('', 'add')">
                            <v-icon class="my-2 mr-3 white--text" v-text="icons.mdiFolderPlus"></v-icon>
                            <span>{{ $gettext('Add Folder') }}</span>
                        </v-col>
                        <v-col @click="$refs.groupsTabRef.openAddEditGroupDialog('', 'add')">
                            <v-icon class="my-2 mr-3 white--text" v-text="icons.mdiAccountMultiplePlus"></v-icon>
                            <span>{{ $gettext('Add Group') }}</span>
                        </v-col>
                    </v-row>

                </v-col>
                <v-col v-else-if="(currentTab === 5 && $vuetify.breakpoint.smAndDown) && currentSelectedConfiguration"
                    class="text-center primary text-center white--text cursor-pointer" cols="12">
                    <div @click="clearCurrentSelectedConfiguration()">
                        <v-icon class="white--text" v-text="icons.mdiArrowLeftCircle"></v-icon>
                        {{ $gettext('Back to Configurations') }}
                    </div>
                    <!--                    <div v-else @click="$refs.mobileAppsTabRef.openAddEditConfigurationDialog()">
                                            <v-icon class="my-2 mr-3 white&#45;&#45;text" v-text="icons.mdiFileDocumentPlusOutline"></v-icon>
                                            <span>{{ $gettext('Add Configuration') }}</span>
                                        </div>-->
                </v-col>
                <v-col v-else class="footer-wrapper" cols="12">
                    <v-row>
                        <v-col class="text-left" cols="4">
                            <span
                                v-if="currentConnection?.value?.type?.toLowerCase() === 'ftp' && $vuetify.breakpoint.mdAndUp"
                                class="subtitle-1 text-truncate">{{
                                    $gettextInterpolate($gettext('You\'re connected to %{ username } @ %{ server }'), {
                                        username: currentConnection.value.username,
                                        server: currentConnection.value.server
                                    })
                                }}
                            </span>
                        </v-col>
                        <v-col cols="4">
                            <span class="mr-auto">
                                <strong>&copy; Lightphone</strong>&nbsp;{{ new Date().getFullYear() }} {{
                                    appVersion
                                }}

                                <span v-if="configurationVersion">({{ configurationVersion }})</span>

                                — {{
                                    $gettext('All Rights Reserved')
                                }}
                            </span>
                        </v-col>
                        <v-col cols="4">
                            <language-chooser></language-chooser>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <!--<save-floating-button v-if="$vuetify.breakpoint.mdAndUp"></save-floating-button>-->

        </v-footer>
        <!--        <v-badge
                    avatar
                    bordered
                    overlap
                    :icon="icons.mdiContentSave"
                    class="mr-4"
                    color="accent"
                    style="position: absolute; bottom: 100px; right: 0px; z-index:100"
                >
                    <v-btn
                        fab
                        dark
                        small
                        color="secondary"
                        @click.native.prevent="configIdefix3Persist()"
                    >
                        <v-icon dark>
                            {{ icons.mdiCodeJson }}
                        </v-icon>
                    </v-btn>
                </v-badge>-->
        <snackbar ref="snackbar"></snackbar>
    </fragment>
</template>
<style type="text/scss">
/*.fixed-tabs-bar .v-tab {
    position: -webkit-sticky;
    position: sticky;
    top: 4rem;
    z-index: 2;
}*/

.footer-button {
    width: 100%;
    /* height: 50px !important; */
    border-radius: 0;
}

.border-separator-right {
    border-right: 1px solid white;
}

.user-tabs-on-mob .v-slide-group__prev.v-slide-group__prev--disabled {
    min-width: 0;
    flex: none;
}

.color-green {
    color: #729772 !important;
}

.color-red {
    color: #f46363 !important;
}

.color-blue {
    color: #2196f3 !important;
}

.expansion-panel-content-border {
    border: 1px solid #eee;
}

.icon-size-sm .v-icon__svg {
    height: 22px;
    width: 22px;
}

.icon-size-20 .v-icon__svg {
    height: 20px;
    width: 20px;
}

.align-flex-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.align-flex-start {
    display: flex;
    align-items: center;
    justify-content: flex-start
}

.set-container {
    max-width: 1800px;
    box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
    -webkit-box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
    -moz-box-shadow: 0px 20px 18px 0px rgb(0 0 0 / 30%);
}

/*.parent-list button.v-expansion-panel-header.v-expansion-panel-header--active.v-expansion-panel-header--mousedown {
   background-color: #e0e0e0 !important;
}*/
</style>

<script>

// @ is an alias to /src
import Vue from 'vue'
import Fragment from 'vue-fragment'
import UsersAndCategoriesTab from '@/components/UsersAndCategoriesTab.vue'
import InternetFilterTab from '@/components/InternetFilterTab.vue'
import CategoriesTab from '@/components/CategoriesTab.vue'
import InformationTab from '@/components/InformationTab'
import GroupsTab from '@/components/GroupsTab'
import UsageTimeTab from '@/components/UsageTimeTab.vue'
import PersonalControlsTab from '@/components/PersonalControlsTab.vue'

import VueSweetalert2 from 'vue-sweetalert2'
import MixinIcon from '@/mixins/MixinIcon'
import 'sweetalert2/dist/sweetalert2.min.css'
import MixinConfig from '@/mixins/database/MixinConfig'
import Snackbar from '@/components/Snackbar'
import MixinAuthentication from '@/mixins/MixinAuthentication'
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { useGroupsStore } from '@/stores/GroupsStore'
import { useConnectionsStore } from '@/stores/ConnectionsStore'
import { useRulesStore } from '@/stores/RulesStore'
import { useUsersStore } from '@/stores/UsersStore'
import { version } from '../../package'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import { mapState, mapWritableState, storeToRefs } from 'pinia'
import { findIndex, isArray } from 'lodash'
import MixinGenericLocalStorage from '@/mixins/MixinGenericLocalStorage'
import MixinGenericHelper from '@/mixins/generic/MixinGenericHelper'
import { eventBus } from '@/main'
import MixinConfigConnection from '@/mixins/database/MixinConfigConnection'
import Constants from '@/assets/js/constants'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import { useProgressBarsStore } from '@/stores/ProgressBarStore'
import { useMainTabsStore } from '@/stores/MainTabStore'
import LanguageChooser from '@/components/LanguageChooser'
import MixinConfigInformation from '@/mixins/database/MixinConfigInformation'
import { useInformationStore } from '@/stores/InformationStore'
import ProfileApplicationTab from '@/components/profiles/ProfileApplicationTab.vue'
import { usePhonesStore } from "@/stores/PhonesStore";
import { useLoginStore } from "@/stores/LoginStore";
import SaveFloatingButton from "@/views/SaveFloatingButton.vue";
import { usePhoneTypesStore } from "@/stores/PhoneTypesStore";
import { useOptionsStore } from "@/stores/OptionsStore";
import axios from "axios";
import { useIdefix3AdditionalFields } from "@/stores/Idefix3AdditionalFieldsStore";
import draggable from 'vuedraggable'
import MixinListing from "../mixins/listing/MixinListing";
import SecurityTab from '@/components/SecurityTab.vue'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import MixinPersonalControl from '@/mixins/MixinPersonalControl'
import { usePersonalControlsStore } from '@/stores/PersonalControlsStore'

Vue.use(VueSweetalert2)
Vue.use(Fragment.Plugin)

export default {
    name: 'Home',
    mixins: [MixinIcon, MixinConfig, MixinAuthentication, MixinGenericComponent, MixinGenericLocalStorage, MixinGenericHelper, MixinConfigConnection, MixinSwalConfirmation, MixinConfigInformation, MixinListing, MixinPersonalControl],
    components: {
        draggable,
        SaveFloatingButton,
        LanguageChooser,
        UsersAndCategoriesTab,
        InternetFilterTab,
        CategoriesTab,
        InformationTab,
        GroupsTab,
        Snackbar,
        ProfileApplicationTab,
        UsageTimeTab,
        PersonalControlsTab,
        SecurityTab,
    },
    beforeDestroy() {
        // Stop listening
        eventBus.$off('currentConnectionChanged', this.handleCurrentConnectionChanged)
        const personalControlsStore = usePersonalControlsStore()
        personalControlsStore.stopAvailabilityCheck()
    },
    watch: {
        currentTab(newValue) {
            if (newValue === 'security') {
                this.$router.push({ name: 'security' });
            }
        }
    },
    data() {
        return {
            homeProgressBar: false,

            // Generic
            users: {
                value: ''
            },
            rules: {
                value: ''
            },

            // Internet Filter Tab
            currentSelectedRuleKey: '',
            currentSelectedRule: '',
            ruleCompact: '',
            isShowFilter: '',
            currentFilterMode: 'all',

            /*rulePanel: '',
            isShowSearch: '',
            categoryPanel: '',
            userPanel: [],*/

            internetFilterSelectedRuleKey: '',

            tabs_icons: {
                'users': 'mdi-account-group',
                'filter': 'mdi-information',
                'info': 'mdi-web-box'
            },
            appVersion: version,

            options: {
                safesearch: 1,
                youtubeRestrict: 1,
                nextDNS: 1,
                oisd: 0,
                adGuard: 0,
                secureGoogle: 1,
                blockTrackers: 0
            },
            safeSearchEnabled: false,
            youtubeRestrictEnabled: false,
            googleSafeBrowsingEnabled: false,
            nightBreakEnabled: false,
            nightBreakStart: '22:00',
            nightBreakEnd: '07:00',
        }
    },

    async beforeRouteLeave(to, from, next) {

        let self = this

        if (self.configHasUnsavedChanges()['status']) {
            // remove the event listeners
            self.beforeunloadListenerTracker = 'exitListening'
            next()
        } else {
            next()
        }

    },

    async mounted() {

        let self = this
        let connection = false;

        self.requiresAuthentication()
        eventBus.$on('currentConnectionChanged', this.handleCurrentConnectionChanged)

        await self.loadConnections()

        if (self.loginModeIsFtp) {
            connection = self.loadConnectionFromFtp()
        } else {

            if (self.loginModeIsSupport) {

                let connections = [];
                self.supportClients.forEach(client => {

                    connections.push({
                        key: client.clientName,
                        value: {
                            id: client.id,
                            clientName: client.clientName,
                            clientPassword: client.clientPassword
                        }
                    })

                })

                self.connections = connections;

                let currentConnection = self.connections.filter(c => c.key === self.supportChosenClient);

                if (currentConnection.length) {
                    connection = currentConnection[0];
                    Vue.set(this, 'currentConnection', connection)
                }

            }

        }

        self.loadEverything(connection)

        // self.updateFtpActiveStatusInIntervalIfApplicable()
        // self.showApplicationsTabConditionally()

    },

    computed: {

        ...mapWritableState(useLoginStore, {
            loginMode: 'loginMode',
            ftpServer: 'ftpServer',
            ftpUsername: 'ftpUsername',
            ftpPassword: 'ftpPassword',
            supportChosenClient: "supportChosenClient",
            supportClients: 'supportClients'
        }),
        ...mapWritableState(useConnectionsStore, {
            currentConnection: 'currentConnection',
            connections: 'connections'
        }),
        ...mapWritableState(useProgressBarsStore, {
            saveProgressBar: 'saveProgressBar',
        }),
        ...mapWritableState(useMainTabsStore, {
            currentTab: 'currentTab',
            tabs: 'tabs',
            tabIndices: 'tabIndices'
        }),
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
            currentSelectedGroup: 'currentSelectedGroup',
            currentSelectedGroupName: 'currentSelectedGroupName',
        }),
        ...mapWritableState(usePhonesStore, {
            currentSelectedConfiguration: 'currentSelectedConfiguration'
        }),
        ...mapState(usePhonesStore, {
            configurations: 'configurations'
        }),
        loginModeIsFtp() {
            return this.loginMode === Constants.login.ftpOnly
        },
        loginModeIsSupport() {
            return this.loginMode === 'support'
        },
        loginModeIsLocal() {
            return this.loginMode === 'local'
        },
        ...mapState(usePhoneTypesStore, {
            phoneTypes: "phoneTypes"
        }),


        ...mapState(useIdefix3AdditionalFields, {
            configurationVersion: 'version'
        }),

    },

    methods: {

        loadConnectionFromFtp() {

            let self = this;

            return {
                key: 'Ftp',
                value: {
                    type: 'ftp',
                    isValid: 1,
                    server: self.ftpServer,
                    username: self.ftpUsername,
                    password: self.ftpPassword
                }
            }

        },

        updateFtpActiveStatusInIntervalIfApplicable() {

            let self = this

            const updateOnTheServer = async () => {

                // We don't want to touch the status.json when we are saving, as the save code already touches the status.json
                if (!self.saveProgressBar && self.currentConnection?.value?.type && self.currentConnection?.value?.type.toLowerCase() === 'ftp' && self.$route.name === 'Home') {

                    try {
                        await self.configStatusUpdateConnectionCurrentlyActive()
                    } catch (e) {
                        // FIXME: REMOVE THIS
                        console.log('error', e)
                    }

                }

            }

            setInterval(async () => {
                await updateOnTheServer();
            }, 60000)

        },

        handleCurrentConnectionChanged(details) {

            let self = this

            if (details.value.hasOwnProperty('key') && typeof details.value.key !== 'undefined') {

                if (details.hasOwnProperty('operation') && details.operation && (details.operation === 'update' || details.operation === 'add' || details.operation === 'change' || details.operation === 'delete')) {
                    self.loadEverything(details.value)
                }

            }

        },

        /**
         * It is important that we reset otherwise, we risk of sending the old data of previous connection if save were to happen suddenly.
         *
         */
        resetEverything() {

            let self = this
            self.users = ''
            self.rules = ''
            self.currentSelectedRuleKey = ''
            self.currentSelectedRule = ''
            self.currentSelectedGroup = ''
            self.currentSelectedGroupName = ''
            // Put all stores in their initial states
            // Do not reset connections store here!
            useCategoriesStore().$reset()
            useGroupsStore().$reset()
            useRulesStore().$reset()
            useUsersStore().$reset()
            useInformationStore().$reset()
            usePhonesStore().$reset()
            usePhoneTypesStore().$reset()
            useProgressBarsStore().$reset()
            useOptionsStore().$reset()
            // useMainTabsStore().$reset()
            // useGeneralStore().$reset()

        },

        async loadConnections() {

            let self = this

            if (self.genericLocalStorageSupportsLocalStorage()) {

                const connectionsStore = useConnectionsStore()

                let connections = await self.genericLocalStorageGetItem('connections')
                let connectionsWithoutReactivity = []

                if (connections) {
                    connectionsWithoutReactivity = JSON.parse(JSON.stringify(connections))
                }

                connectionsStore.setConnections(connections)
                connectionsStore.setConnectionsInitialState(connectionsWithoutReactivity)

                if (self.loginMode === Constants.login.ftpOnly) {

                    connectionsStore.setCurrentConnection({
                        key: 'Ftp',
                        value: {
                            type: 'ftp',
                            isValid: 1,
                            server: self.ftpServer,
                            username: self.ftpUsername,
                            password: self.ftpPassword
                        }
                    })

                } else {
                    connectionsStore.setCurrentConnectionIfCurrentConnectionIsNotSetAlready()
                }

            }
        },

        /**
         * All stores are reset first, loaded again from get.php, and the stores are set back again based on what is received from the get.php.
         * If we are unable to load, edit connection is offered here as well.
         *
         * @param connection
         */
        loadEverything(connection = false) {

            let self = this

            self.homeProgressBar = true
            self.saveProgressBar = true

            const unknownError = () => {
                self.$refs?.snackbar?.showSnackbar(self.$gettext('Unknown error occurred. Please try again in sometime'), 'error')
            }

            // It is important that we reset otherwise, we risk of sending the old data of previous connection if save were to happen suddenly.
            self.resetEverything()

            let accountName = false

            let user = useAuthenticationStore().getUser()

            if (!user) {
                console.error('User not found')
                return
            } else {
                accountName = user?.account
            }

            self.configLoadAll(connection, accountName).then(async function (response) {

                if (response && response?.status) {

                    let config = response.data

                    if (typeof config === 'object') {

                        self.configSetVariablesToStores(config, true, connection)

                        // the unsaved changes should not be persisted if the personal store allowedEdits is false
                        // alert only if personalControlsStore.getPersonalControls() is not empty
                        let personalControlsStore = usePersonalControlsStore()
                        let personalControls = personalControlsStore.getPersonalControls()

                        let allowedEdits = personalControlsStore.getAllowedEdits()
                        
                        if (Object.keys(personalControls).length > 0 && !allowedEdits) {
                            self.alertThatSaveIsNotAllowed()
                        }

                        if (Constants.isDevelopmentEnvironment) {
                            // self.configLoadInformationAndSetInStores()
                        } else {
                            self.configLoadInformationAndSetInStores()
                        }

                        /**
                         * Covers the scenario where the user has connected to local and then changed to an FTP connection
                         * Solves: https://sheltercom.atlassian.net/jira/software/c/projects/SFILT/issues/SFILT-38
                         */
                        if (connection?.value?.type?.toLowerCase() === 'ftp') {
                            // self.configStatusUpdateConnectionCurrentlyActive();
                        }

                        await self.downloadMissingPhoneIcons(); // let this be last line always as this is the least in priority
                    } else {
                        // TODO: Log error
                    }

                } else {

                    // It is not expected for a user to enter this block. At least not due to invalid ftp connection, as by default the connections are defaulted to local connection, that leaves only one way, i.e. when a change in connection is performed. Before switching connection, we're already validating it, and we're only allowing when it is valid. So, this block should never be entered for that case.

                    // Local requires no configuration/connection. It makes this block completely not in use, unless we're defaulting to ftp connection at some point in the future.

                    if (response.hasOwnProperty('error') && typeof response.error !== 'undefined' && response.error.length > 0) {

                        /*
                        const fnEditConnection = () => {
                            connection.error = response.error; // Just in case, if we want to use it.
                            eventBus.$emit('openAddEditCurrentConnectionEvent')
                        }
                        const fnLoadDefaultConnection = () => eventBus.$emit('fallbackCurrentConnectionToLocalEvent', {error: response.error})

                        let swalOptions = {
                            successCallback: fnEditConnection,
                            title: 'Whoops!',
                            description: 'Error occurred while loading. ' + response.error,
                            confirmButtonText: 'Edit Connection',
                            icon: 'error',
                            cancelButtonText: 'Switch to Local',
                            cancelCallback: fnLoadDefaultConnection,
                            allowOutsideClick: false,
                        }

                        self.swalConfirmation(swalOptions);
                        */

                        if (connection) {
                            self.$refs.snackbar.showSnackbar('Error occurred while loading ' + connection.key + '. ' + response.error, 'error')
                        } else {
                            self.$refs.snackbar.showSnackbar(response.error, 'error')
                        }

                    } else {
                        unknownError()
                    }

                }

            }).catch(function (e) {
                unknownError()

                // FIXME: REMOVE THIS
                console.log(e)

            }).finally(function () {
                self.homeProgressBar = false
                self.saveProgressBar = false
            })

        },

        pushAFilterRule(rule, mode) {
            let self = this
            self.$refs.internetFilterTabRef.pushAFilterRule(rule, mode)
        },

        toggleFilter() {
            let self = this
            self.$refs.internetFilterTabRef.toggleFilter()
        },
        clearCurrentSelectedRule() {
            let self = this
            self.$refs.internetFilterTabRef.clearCurrentSelectedRule()
            // If we don't do this then on mobile, we won't see the listing page. i.e. the one that shows list of rules.
            self.$refs.internetFilterTabRef.ruleFilterValue = ''
        },
        clearCurrentSelectedGroup() {
            let self = this
            self.$refs.groupsTabRef.clearCurrentSelectedGroup()
            // If we don't do this then on mobile, we won't see the listing page. i.e. the one that shows list of groups.
            self.$refs.groupsTabRef.groupFilterValue = ''
        },
        clearCurrentSelectedConfiguration() {
            let self = this
            self.$refs.mobileAppsTabRef.clearCurrentSelectedConfiguration()
            self.$refs.mobileAppsTabRef.configurationFilterValue = ''
        },
        openAddEditRuleDialog() {
            let self = this
            self.$refs.internetFilterTabRef.openAddEditRuleDialog('', 'add')
        },
        openCreateProfileDialog() {
            let self = this
            eventBus.$emit('openCreateProfileDialog')
        },

        async downloadMissingPhoneIcons() {

            /*---------------------------------------------
                We are disabling this as rsync handles the icons now
            ----------------------------------------------*/

            return true;

            let self = this;

            for (let c of self.configurations) {

                let dir = '';

                const phoneTypeIndex = self.phoneTypes.findIndex((phoneType) => {
                    return phoneType.key === c.value.phone_model;
                })

                if (phoneTypeIndex > -1) {
                    dir = self.phoneTypes[phoneTypeIndex].value.dir;
                } else {
                    console.error('Home: Phone type not found');
                }

                try {
                    const response = await axios.get(`mobile_apps.php?phone_model=${c.value.phone_model}&dir=${dir}`);
                } catch (error) {
                    console.error(error);
                }

            }


        },


        /**
         * This considers search parameter/filter as well
         * @returns {boolean}
         */
        currentViewConfigurationCount() {

            let self = this
            let configurationCount = 0

            if (self.configurations && Object.keys(self.configurations).length > 0) {

                for (let key in self.configurations) {
                    self.checkEachConfiguration(self.configurations[key]['key']) ? configurationCount++ : ''
                }

            }

            return configurationCount
        },



        checkEachConfiguration(configurationName) {

            let self = this
            let configurationVisibility = true

            if (self.configurationFilterValue && self.configurationFilterValue.length > 0) {
                configurationVisibility = configurationName && configurationName?.toLowerCase().includes(self.configurationFilterValue.toLowerCase());
            }

            if (configurationVisibility) {
                // this area is left for further filter, not required now but a placeholder
            }

            return configurationVisibility

        },

        configurationSelectedForMobile() {
            let self = this

            // extra lines to increase readability.
            return (
                self.$vuetify.breakpoint.smAndUp

                ||

                (
                    self.$vuetify.breakpoint.mobile &&
                    (
                        self.currentSelectedConfiguration === '' || self.currentSelectedConfiguration === false || self.currentSelectedConfiguration.length === 0
                    )
                )
            )
        },
        updateSecuritySettings() {
            // Implementation of updateSecuritySettings method
        },
        updateNightBreakSettings() {
            // Implementation will come in next steps
            console.log('Updating night break settings')
        },
        selectConfiguration(configurationName) {
            if (configurationName) {
                this.currentSelectedConfiguration = configurationName;
                // Prevent toggle behavior
                this.$nextTick(() => {
                    this.currentSelectedConfiguration = configurationName;
                });
            }
        },
    },
}
</script>
